/** QuickPlan — Angles de vue des illustrations de notice (sans three.js : utilisable par le PDF). */

/** Vue opposée (pour voir l'arrière d'une vue d'ensemble). */
export const OPPOSITE_VIEW = { 'av-d': 'ar-g', 'av-g': 'ar-d', 'ar-d': 'av-g', 'ar-g': 'av-d' };

export const NOTICE_VIEWS = {
  'av-d': { label: 'Avant droite', dir: [1, -1.6, 0.95] },
  'av-g': { label: 'Avant gauche', dir: [-1, -1.6, 0.95] },
  'ar-d': { label: 'Arrière droite', dir: [1, 1.6, 0.95] },
  'ar-g': { label: 'Arrière gauche', dir: [-1, 1.6, 0.95] },
};
